import React from "react";
import { Button as MUIButton } from "@mui/material";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import styles from "./styles";
import Colors from "../../../theme/colors";

const VARIANT = {
  CONTAINED: "contained",
  OUTLINED: "outlined",
};

const CustomMUIButton = styled(MUIButton)({
  " &.Mui-disabled": {
    opacity: 0.7,
    color: Colors.white,
  },
});

function Button({
  disabled,
  isLoading,
  label,
  startIcon,
  variant,
  style,
  ...props
}) {
  return (
    <CustomMUIButton
      sx={{
        ...(variant === VARIANT.CONTAINED ? styles.container : styles.outLined),
        ...(disabled ? styles.disabled : {}),
        ...style,
      }}
      disabled={isLoading || disabled}
      startIcon={!isLoading ? startIcon : null}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {isLoading ? <CircularProgress style={styles.progressBar} /> : label}
    </CustomMUIButton>
  );
}

const propTypes = {
  isLoading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  startIcon: PropTypes.element.isRequired,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.objectOf(),
};

const defaultProps = {
  isLoading: false,
  variant: "contained",
  disabled: false,
  style: {},
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
